import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=35df7b7e&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"
import style0 from "./IconComponent.vue?vue&type=style&index=0&id=35df7b7e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df7b7e",
  null
  
)

export default component.exports